import { render } from "./CadastroMensagensPadraoView.vue?vue&type=template&id=f007f30c"
import script from "./CadastroMensagensPadraoView.vue?vue&type=script&lang=js"
export * from "./CadastroMensagensPadraoView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\SGCAD25\\Induscapas\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__